module.exports = __webpack_public_path__ + "img/backbutton-grey.f65f350b.svg";